import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface CutoutInfoType {
    left: number;
    total: number;
}

export interface ICutoutModel {
    cutoutInfo: CutoutInfoType;
    setCutoutInfo: (cutoutInfo: CutoutInfoType) => void;
}

const useCutoutModel = create<ICutoutModel>()(
    immer((set) => ({
        cutoutInfo: {
            left: 0,
            total: 0,
        },
        setCutoutInfo: (cutoutInfo) =>
            set((state) => {
                const { left, total } = cutoutInfo;
                state.cutoutInfo = { left, total };
            }),
    })),
);

export { useCutoutModel };
export const getCutoutModel = () => useCutoutModel.getState();
